import cRequest from "@services/c-request"
import { AddVehicleProps, BulkAddVehicleProps } from "./vehicle.types"
import { snakeCase } from "change-case/keys"

const vehicleModelsPath = `${process.env.REACT_APP_BASE_URL}/data/vehicles`
const vehiclesPath = `${process.env.REACT_APP_BASE_URL}/vehicles`

export const vehicleModelsService = async () => {
  return cRequest
    .get(vehicleModelsPath)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

const formatAddVehicleBody = (
  body: AddVehicleProps | BulkAddVehicleProps
): AddVehicleProps | BulkAddVehicleProps => {
  if ("multiple" in body && body.multiple && body.vehicles?.length) {
    return {
      multiple: body.multiple,
      vehicles: body.vehicles.map((vehicle) => snakeCase(vehicle)),
    }
  }

  return snakeCase(body)
}

export const addVehicleService = async (
  body: AddVehicleProps | BulkAddVehicleProps
) => {
  const udpated = formatAddVehicleBody(body)

  return cRequest
    .post(`${vehiclesPath}/add-vehicle`, udpated)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getSingleVehicleService = async (vid: any) => {
  return cRequest
    .get(`${vehiclesPath}/get-vehicle-single`, { params: { vid } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getVehiclesService = async (uid: any) => {
  return cRequest
    .get(`${vehiclesPath}/get-vehicles`, { params: { uid } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getAllVehiclesService = async (
  createdAt: string,
  key?: string,
  value?: string
) => {
  return cRequest
    .get(`${vehiclesPath}/get-all-vehicles`, {
      params: { createdAt, key, value },
    })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const editVehicleService = async (body: any) => {
  return cRequest
    .put(`${vehiclesPath}/edit-vehicle`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}
